import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { useRealSchoolSettings } from "@/hooks/useRealSchoolSettings";
import { useStageOrdering } from "@/hooks/useStageOrdering";
import { SchoolSettingsHeader } from "@/components/settings/core/SchoolSettingsHeader";
import { SchoolSettingsTabs } from "@/components/settings/core/SchoolSettingsTabs";
import { UserRoleGuard } from "@/components/settings/core/UserRoleGuard";
import { UnifiedLoadingSpinner } from "@/components/loading/UnifiedLoadingSpinner";
import { useAuth } from "@/hooks";

const SchoolSettings = () => {
  const { settings, loading, updateSettings } = useRealSchoolSettings();
  const { toast } = useToast();
  const [tempSchoolName, setTempSchoolName] = useState("");
  const orderedStages = useStageOrdering(settings?.stages);
  // const { user, userProfile } = useAuth();

  // التحقق من نوع المستخدم
  // useEffect(() => {
  //   const checkUserRole = async () => {
  //     const { data: { user } } = await supabase.auth.getUser();
  //     if (user) {
  //       const { data: profile } = await supabase
  //         .from('profiles')
  //         .select('role')
  //         .eq('id', user.id)
  //         .maybeSingle();

  //       setUserRole(profile?.role || null);
  //     }
  //   };

  //   checkUserRole();
  // }, []);

  // تحديث اسم المدرسة المؤقت عند تحميل الإعدادات
  useEffect(() => {
    if (settings?.school_name) {
      setTempSchoolName(settings.school_name);
    }
  }, [settings?.school_name]);

  const handleSaveSettings = async () => {
    // نتأكد من عدم إزالة المسافات المهمة، فقط إزالة المسافات الزائدة في البداية والنهاية
    const trimmedName = tempSchoolName.trim();
    if (trimmedName) {
      console.log("حفظ اسم المدرسة:", trimmedName);
      await updateSettings({ school_name: trimmedName });
      toast({
        title: "تم الحفظ بنجاح",
        description: "تم تحديث اسم المدرسة بنجاح",
      });
    }
  };

  if (loading) {
    return (
      <div
        className="container mx-auto px-4 py-2 flex justify-center items-center min-h-screen"
        dir="rtl"
      >
        <UnifiedLoadingSpinner size="md" />
      </div>
    );
  }

  // Check for role guards
  // const roleGuard = UserRoleGuard({
  //   userRole: userProfile?.role,
  //   hasSettings: !!settings,
  // });
  // if (roleGuard) {
  //   return roleGuard;
  // }

  return (
    <div
      className="min-h-screen font-tajawal bg-gradient-to-br from-primary-teal/5 via-primary-blue/3 to-primary-green/5"
      dir="rtl"
    >
      <div className="container mx-auto px-4 py-8">
        <SchoolSettingsHeader />

        <SchoolSettingsTabs
          settings={settings!}
          orderedStages={orderedStages}
          tempSchoolName={tempSchoolName}
          setTempSchoolName={setTempSchoolName}
          handleSaveSettings={handleSaveSettings}
          updateSettings={updateSettings}
        />
      </div>
    </div>
  );
};

export default SchoolSettings;
